import styled from 'styled-components';

export const BrowseCatWrapper = styled.section`
  padding: ${(props) =>
    props.fromSearchPage
      ? ' 0'
      : props.padding && !props.fromSuccessPage
        ? '30px 7.5%'
        : props.noPadding
          ? '0'
          : '0 7.5%'};
  margin: ${(props) =>
    props.fromSuccessPage || props.fromSearchPage ? '0' : '50px 0 40px'};
  background: linear-gradient(
    to bottom,
    ${(props) => props.sectionBgColorStart},
    ${(props) => props.sectionBgColorEnd}
  );
  @media (max-width: 720px) {
    margin: ${(props) =>
      props.noMwebPadding || props.fromSuccessPage || props.fromSearchPage
        ? '0'
        : '34px 0 0'};
    padding: ${(props) => (props.padding ? '20px 0' : '0 ')};
  }
`;

export const BrowseCatStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(
    ${(props) =>
      props.fromSearchPage
        ? '6'
        : props.fromSuccessPage
          ? '4'
          : props.columnSize},
    1fr
  );
  /* justify-content: ${(props) =>
    props.filterStoreCard ? 'flex-start' : 'flex-start'}; */
  justify-content: flex-start;
  align-items: ${(props) =>
    props.fromSuccessPage || props.fromSearchPage || props.fromBabyNames
      ? 'baseline'
      : 'center'};
  flex-wrap: wrap;
  padding: ${(props) =>
    props.fromBabyNames
      ? '20px 1% 0'
      : props.fromSearchPage
        ? '0 1% 20px'
        : ' 0 7.5%'};
  gap: 30px;
  @media (max-width: 720px) {
    gap: ${(props) => (props.fromSearchPage ? '22px' : '12px')};
    grid-template-columns: repeat(
      ${(props) =>
        props.fromSearchPage
          ? props.columnSize
          : props.fromSuccessPage
            ? '4'
            : props.columnSize / 2},
      1fr
    );
    align-items: flex-start;
    padding: ${(props) => (props.fromBabyNames ? '0 12px' : '0 10px')};
  }
`;

export const BrowseCatTitle = styled.h1`
  text-align: center;
  padding: '0 10px 30px';

  @media (max-width: 720px) {
    padding: 0 10px 20px;
  }

  h2 {
    display: inline-block;
    color: hsl(0deg, 0%, 0%, 80%);
    position: relative;
    font-size: clamp(20px, 2vw, 24px);
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 5px;
    @media (max-width: 720px) {
      letter-spacing: 3px;
    }
  }
`;

export const BrowseImageBox = styled.div`
  text-align: center;
  cursor: pointer;
  transition:
    transform 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s,
    box-shadow 0.3s ease 0s,
    -webkit-transform 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s;
  &:hover {
    transform: scale(1.026);
  }

  @media (max-width: 720px) {
    cursor: default;
  }

  span {
    position: unset !important;
  }

  img {
    object-fit: contain;
    width: 100% !important;
    position: relative !important;
    height: unset !important;
  }
  .lowOpacity {
    opacity: 0.6;
  }
`;

export const BrowseCategoryName = styled.p`
  font-size: clamp(11px, 2vw, 16px);
  font-weight: ${(props) => (props.fromSearchPage ? '500' : '600')};
  color: hsl(0deg, 0%, 0%, 87%);
  padding: 12px 0 8px;

  @media (max-width: 720px) {
    text-transform: capitalize;
  }
`;

export const BrowseCatImage = styled.img`
  width: 100%;
  max-width: ${(props) => (props.fromSuccessPage ? '160px' : '182px')};
  height: 100%;
  background: url(https://images.myloapp.in/NestJsUploads/1668753299328-default_image_white_vtMCZCeFi.webp);
`;
